"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var engine = {
    SPECK_PACK: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment SpecPack on SpecPack {\n      code\n      attributes {\n        shortname\n        nviccode @include(if: $dataLayer)\n      }\n    }\n  "], ["\n    fragment SpecPack on SpecPack {\n      code\n      attributes {\n        shortname\n        nviccode @include(if: $dataLayer)\n      }\n    }\n  "]))),
};
exports.default = engine;
var templateObject_1;
